import Vue from 'vue';
import { createApp } from '@/app';

Vue.mixin({
  beforeRouteUpdate(to, from, next) {
    const { asyncData } = this.$options;
    if (typeof asyncData === 'function') {
      asyncData.call(this.$options, {
        store: this.$store,
        route: to,
        // eslint-disable-next-line no-mixed-operators
        params: to && to.query || {},
      }).then(next)
        .catch(next);
    } else {
      next();
    }
  },
  beforeCreate() {
    if (this.$store && typeof (this.$store.registerModules) === 'function') {
      this.$store.registerModules(this.$options.storeModules);
    }
  },
  destroyed() {
    if (this.$store && typeof (this.$store.registerModules) === 'function') {
      this.$store.unregisterModules(this.$options.storeModules);
    }
  },
});

const { app, router, store } = createApp();

const routerReady = () => {
  router.beforeResolve((to, from, next) => {
    const matched = router.getMatchedComponents(to);
    const prevMatched = router.getMatchedComponents(from);
    const total = matched.length - 1;
    let i = 0;
    while (i <= total) {
      if (matched[i] !== prevMatched[i]) {
        break;
      }
      i += 1;
    }
    if (i > total) {
      next();
    } else {
      Promise.all(matched.slice(i).map((component) => {
        const { asyncData } = component;
        if (typeof asyncData === 'function') {
          return asyncData({
            store: store.registerAllModules(component),
            route: to,
            // eslint-disable-next-line no-mixed-operators
            params: to && to.query || {},
          });
        }
        return Promise.resolve();
      })).then(() => {
        prevMatched.slice(i).forEach((component) => {
          store.unregisterAllModules(component);
        });
        next();
      })
        .catch((e) => {
          console.error(e);
          prevMatched.slice(i).forEach((component) => {
            store.unregisterAllModules(component);
          });
          next();
        });
    }
  });
  app.$mount('#app');
};

// eslint-disable-next-line no-underscore-dangle
if (window.__INITIAL_STATE__) {
  // eslint-disable-next-line no-underscore-dangle
  store.replaceState(window.__INITIAL_STATE__);
  router.onReady(routerReady);
} else {
  routerReady();
}
